module.exports = __webpack_public_path__ + "static/media/phaneroptera_nana_015_APA.28769e33.png";